// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ec66ca96","712":"fecc89fe","855":"40c0afa9","900":"429513e1"}[chunkId] + ".chunk.js";
};